import moment from 'moment';

export function useMoment() {
  return moment;
}
